import { useEffect, useMemo, useState, type FC } from 'react';

import { ExpandLess } from '@mui/icons-material';
import { Avatar, Button, Divider, Grid, Skeleton, SvgIcon } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import { ArrowDownIcon } from '../dashboard-icon';
import { OverviewDoneTasks } from './overview-tasks';
// import { OverviewDoneTasks } from './overview-done-tasks';
interface TaskStatusProps {}

export const TaskStatus: FC<TaskStatusProps> = (props) => {
  const dashboardOverviewLoader = useSelector((state: any) => state.dashboardOverviewReducer);
  const dashboardOverview = useSelector((state: any) => state.dashboardOverviewReducer?.response);
  const dashboardDocumentationResponse = useSelector(
    (state: any) => state.dashboardDocumentationReducer?.response
  );
  const dashboardTherapyResponse = useSelector(
    (state: any) => state.dashboardTherapyReducer?.response
  );
  const dataMap = useMemo(
    () => [dashboardTherapyResponse, dashboardDocumentationResponse, dashboardOverview],
    [dashboardTherapyResponse, dashboardDocumentationResponse, dashboardOverview]
  );

  const [showTaskDetails, setShowTaskDetails] = useState(false);
  const [taskListData, setTaskListData] = useState<any>({});

  const handleShowTask = () => {
    setShowTaskDetails((prev) => !prev);
  };

  // useEffect(() => {
  //   if (dashboardOverview?.length > 0) {
  //     const getTaskOverviewList = dashboardOverview?.map((taskInfo: any) => {
  //       const { date, ...restPatient } = taskInfo;
  //       return {
  //         ...restPatient,
  //         isSingleOpen: false,
  //       };
  //     });

  //     setTaskListData(getTaskOverviewList);
  //   }
  // }, [dashboardOverview,dashboardDocumentationResponse,dashboardTherapyResponse]);

  // const handleSingleTask = (taskName: any) => {
  //   const updatedData = taskListData.map((task: any) => {
  //     if (task?.name === taskName?.name) {
  //       return { ...task, isSingleOpen: !task?.isSingleOpen };
  //     }
  //     return task;
  //   });
  //   setTaskListData(updatedData);
  // };

  return (
    <Card
      sx={{
        // height: '330px',
        height: '90%',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        pt: 2,
      }}
    >
      {/* <Box
        // pl={3}
        pt={1}
        sx={{ height: '46px', marginBottom: '20px' }}
      >
        <Typography
          sx={{
            marginTop: 2,
            marginLeft: '15px',
          }}
          variant="h6"
        >
          Overview
        </Typography>
      </Box> */}

      <Grid
        xs={12}
        container
        sx={{ height: '50%', border: '' }}
      >
        {dashboardOverviewLoader?.loading ? (
          <>
            {['1', '2', '3'].map((load) => {
              return (
                <Grid
                  key={load}
                  xs={4}
                  sx={{ height: '100%' }}
                >
                  <Card
                    sx={{
                      borderRadius: '0px',
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      padding: 2,
                    }}
                  >
                    <Box sx={{ display: 'flex', width: '100%', alignItems: 'center', gap: 1 }}>
                      <Skeleton
                        animation="pulse"
                        variant="circular"
                      >
                        <Avatar sx={{ width: 70, height: 70 }} />
                      </Skeleton>
                      <Box sx={{ width: '100%' }}>
                        <Typography
                          width={'100%'}
                          variant="h5"
                        >
                          <Skeleton animation="pulse" />
                        </Typography>
                        <Typography
                          width={'30%'}
                          variant="h5"
                        >
                          <Skeleton animation="pulse" />
                        </Typography>
                        <Typography
                          marginTop={3}
                          width={'100%'}
                          variant="h6"
                        >
                          <Skeleton animation="pulse" />
                        </Typography>
                      </Box>
                    </Box>
                  </Card>
                </Grid>
              );
            })}
          </>
        ) : (
          <Grid
            container
            spacing={2}
          >
            {dataMap.map((data, index) => (
              <Grid
                key={index}
                item
                xs={4}
                sx={{ height: '100%' }}
              >
                <OverviewDoneTasks
                  showTaskDetails={showTaskDetails}
                  index={index}
                  dataRes={data}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </Grid>
      <Divider />
      <Box sx={{ display: 'flex', height: '60px', justifyContent: 'center', alignItems: 'center' }}>
        <Button
          color="inherit"
          endIcon={
            <SvgIcon sx={{ marginTop: showTaskDetails ? '3px' : '4px' }}>
              {!showTaskDetails ? <ArrowDownIcon /> : <ExpandLess />}
            </SvgIcon>
          }
          onClick={handleShowTask}
          size="small"
          sx={{ color: '#BDBDBD', fontWeight: 600, fontSize: '13px' }}
        >
          {showTaskDetails ? 'Hide Details' : 'Show Details'}
        </Button>
      </Box>
    </Card>
  );
};
